import Phaser from "phaser";

export function createDissolveEffect(entity: Phaser.Physics.Arcade.Sprite,
                                     particleContainer: Phaser.GameObjects.Container) {
    const texture = entity.scene.textures.get(entity.texture.key);
    const frame = entity.frame;
    const sourceX = frame.cutX;
    const sourceY = frame.cutY;
    const width = frame.width;
    const height = frame.height;

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');

    const textureSource = texture.getSourceImage();
    ctx!.drawImage(
        textureSource as CanvasImageSource,
        sourceX, sourceY,
        width, height,
        0, 0,
        width, height
    );

    const imageData = ctx!.getImageData(0, 0, width, height);
    const pixels = imageData.data;

    const pixelInterval = 2;
    const particles: Phaser.GameObjects.Particles.ParticleEmitter[] = [];

    const worldX = entity.x - entity.displayWidth / 2;
    const worldY = entity.y - entity.displayHeight / 2;

    const centerX = entity.scene.cameras.main.centerX;
    const centerY = entity.scene.cameras.main.centerY;

    for (let y = 0; y < height; y += pixelInterval) {
        for (let x = 0; x < width; x += pixelInterval) {
            const pixelIndex = (y * width + x) * 4;
            const r = pixels[pixelIndex];
            const g = pixels[pixelIndex + 1];
            const b = pixels[pixelIndex + 2];
            const alpha = pixels[pixelIndex + 3];

            if (alpha > 0) {
                const particleX = worldX + (x * entity.scaleX);
                const particleY = worldY + (y * entity.scaleY);

                const angleToCenter = Phaser.Math.Angle.Between(
                    centerX,
                    centerY,
                    particleX,
                    particleY
                );

                const angleVariation = Phaser.Math.Between(-15, 15);
                const angleDegrees = Phaser.Math.RadToDeg(angleToCenter) + angleVariation;

                const color = ((r << 16) | (g << 8) | b);

                const emitter = entity.scene.add.particles(0, 0, 'pixel', {
                    x: particleX,
                    y: particleY,
                    speed: { min: 75, max: 150 },
                    angle: {
                        min: angleDegrees - 5,
                        max: angleDegrees + 5
                    },
                    scale: { start: 1, end: 0 },
                    tint: color,
                    lifespan: { min: 250, max: 500 },
                    gravityY: 100,
                    quantity: 1,
                    frequency: -1
                });

                particleContainer.add(emitter);
                particles.push(emitter);

                emitter.explode(1, particleX, particleY);
            }
        }
    }

    entity.scene.time.delayedCall(2500, () => {
        particles.forEach(emitter => emitter.destroy());
    });
}
